module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ua-2dd397cb920452449acaff2aa80a167d.svg";